import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest(
    'put',
    `/api/live_discussions/${liveID}/participations/me/toggle-video`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/toggleOwnVideo.js